import React, { useEffect, useRef } from "react";
import { ChevronDown, ChevronUp } from "react-feather";
import { useSpring, animated } from "react-spring";

const QuestionAns = ({ question, answer, isOpen, onToggle, html = false }) => {
  const contentRef = useRef(null);

  const animationStyles = useSpring({
    opacity: isOpen ? 1 : 0,
    height: isOpen ? `${contentRef.current?.scrollHeight}px` : "0px",  // Fixed height calculation
    overflow: "hidden",
    config: { duration: 200 },
  });

  return (
    <div className="bg-white rounded-2xl p-4 shadow-md flex flex-col gap-2">
      <div
        className="flex justify-between px-4 items-center cursor-pointer"
        onClick={onToggle}
      >
        <h2 className="font-secondary font-semibold md:text-2xl text-xl">
          {question}
        </h2>

        <div className="cursor-pointer">
          {isOpen ? <ChevronUp className="text-primary" /> : <ChevronDown />}
        </div>
      </div>
      <animated.div style={animationStyles} className="px-4">
        {html ? <div ref={contentRef} dangerouslySetInnerHTML={{ __html: answer }} /> : <div ref={contentRef}>{answer}</div>}
      </animated.div>
    </div>
  );
};

export default QuestionAns;
